export const Events = {
	modal_with_form_crm: "react-modal-with-form-crm",
	plus_button_crm: "react-plus-button-crm",

	subsidiary_list: "react-subsidiary-list",
	subsidiary_edit: "crm-subsidiary-edit",
	subsidiary_delete: "crm-subsidiary-delete",
	load_form_subsidiary: "load-form-subsidiary",
	filter_subsidiaries_fired: "filter-subsidiaries-fired",
	new_subsidiary_hide_modal: "crm-new-subsidiary-hide-modal",
	edit_subsidiary_hide_modal: "crm-edit-subsidiary-hide-modal",

	agents_list: "react-agents-list",
	agent_edit: "crm-agent-edit",
	agent_delete: "crm-agent-delete",
	load_form_agent: "load-form-agent",
	filter_agents_fired: "filter-agents-fired",
	new_agent_hide_modal: "crm-new-agent-hide-modal",
	edit_agent_hide_modal: "crm-edit-agent-hide-modal",
};
